import SAT from "sat";
import type { ObstacleData, PickupData } from "../types";

export interface BodyState {
  x: number;
  y: number;
  radius: number;
  width?: number;
  height?: number;
  offsetY?: number;
}

export class CollisionSystem {
  private response = new SAT.Response();

  resolveObstacles(body: BodyState, obstacles: ObstacleData[]) {
    let hits = 0;
    for (const obstacle of obstacles) {
      if (!obstacle.blocking) continue;
      const bodyWidth = body.width ?? body.radius * 2;
      const bodyHeight = body.height ?? body.radius * 2;
      const bodyY = body.y + (body.offsetY ?? 0);
      const player = new SAT.Box(new SAT.Vector(body.x - bodyWidth * 0.5, bodyY - bodyHeight * 0.5), bodyWidth, bodyHeight).toPolygon();
      const width = obstacle.width * 0.56;
      const height = obstacle.height * 0.48;
      const polygon = new SAT.Box(new SAT.Vector(obstacle.x - width * 0.5, obstacle.y - height * 0.5), width, height).toPolygon();
      this.response.clear();
      if (SAT.testPolygonPolygon(player, polygon, this.response)) {
        body.x -= this.response.overlapV.x * 1.1;
        body.y -= this.response.overlapV.y * 1.1;
        hits += 1;
      }
    }
    return hits;
  }

  collectPickups(body: BodyState, pickups: PickupData[]) {
    const collected: PickupData[] = [];
    for (const pickup of pickups) {
      if (pickup.collected) continue;
      const distance = Math.hypot(body.x - pickup.x, body.y - pickup.y);
      if (distance <= body.radius + pickup.radius) {
        pickup.collected = true;
        collected.push(pickup);
      }
    }
    return collected;
  }
}
